export default __webpack_public_path__ + "static/media/default-value.193f9184.svg";